/*
 * @Author: your name
 * @Date: 2020-07-01 10:26:41
 * @LastEditTime: 2020-07-04 09:57:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-lib-ui/examples/demos/form-build-demo/form-schema-config/components/form-document-number.config.js
 */
const FormDocumentNumberConfig = {
  // 类型
  componentType: 'FORM_DOCUMENT_NUMBER',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-document-number-icon',
    text: '单据号',
    optionTitle: true,
    description: '根据配置规则自动生成单据号'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormDocumentNumber',
      edit: 'FormDocumentNumber',
      read: 'FormDocumentNumber'
    },
    excludeComponentTypes: [
      'FORM_WIDGET_TABLE',
      'FORM_WIDGET_SPACE'
    ],
    lengthLimit: 200,
    documentNumRules: [],
    label: '单据号',
    placeholder: '请选择单据号规则',
    readOnly: true,
    inTable: true,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      }
    }
  },
  methods: {},
  editorConfig: ['INFO', 'LABEL', 'DOCUMENT_NUMBER_RULE', 'WIDTH', 'HIDDEN'],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormDocumentNumberConfig
